module.exports = __webpack_public_path__ + "static/img/t_shirt.a159cec8.png";